import { render, staticRenderFns } from "./ColorPickerInput.vue?vue&type=template&id=427cb1a6&"
import script from "./ColorPickerInput.vue?vue&type=script&lang=ts&"
export * from "./ColorPickerInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports